import { z } from 'zod';
import { QUERY_PATH_ORIGIN } from '../constants';

export const aggregatePathError = ({ path, message }: z.ZodIssue) => ({
  path: [QUERY_PATH_ORIGIN, ...path].join('.'),
  message,
});
